import { render, staticRenderFns } from "./FormUserCourseRoles.vue?vue&type=template&id=15bdcfae&"
import script from "./FormUserCourseRoles.vue?vue&type=script&lang=js&"
export * from "./FormUserCourseRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports